import React, {useState, useEffect} from 'react';

import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const api ="https://jojomarket.ne/adminfood/functionuser.php?byemail="; 
const userInfoApi = "https://jojomarket.ne/adminfood/functionuser.php?byemail=";

const initialState = {

  email:"",
  password:""
}

  // if (toDashboard === true) {
  //   return <Navigate to="/home" />;
  // }

  // Somewhere in your code, e.g. inside a handler:
 


 function Login(){




  
  const [formValue, setformValue] = React.useState({
 
  email:"",
  password:""
  });

  const navigate = useNavigate();

  const handleChange = (event) => {
    setformValue({
      ...formValue,
      [event.target.name]: event.target.value
    });
  }

  async function TokenStorage(Token) {
    if (Token && Token !== 'erreur') {
      sessionStorage.setItem("Token", Token);
  
      try {
        const res = await axios.get(`${userInfoApi}1&email=${encodeURIComponent(formValue.email)}`);
        const data = (res && typeof res.data === 'string') ? JSON.parse(res.data) : res.data;
  
        console.log('Réponse user info:', data);
  
        if (data) {
          sessionStorage.setItem('NomAdmin', data.nom || '');
          // Store acces in sessionStorage
          if (data.acces && typeof data.acces === 'object') {
            sessionStorage.setItem('Acces', JSON.stringify(data.acces));
            console.log('Acces set from API:', data.acces);
          }
          if (data.post) {
            sessionStorage.setItem('Role', data.post);
            console.log('Role set from API:', data.post);
          }
        } else {
          console.log('Aucune donnée trouvée:', data);
        }
  
        navigate('/');
  
      } catch (e) {
        console.log('Erreur récupération accès:', e);
      }
  
    } else {
      alert('Erreur de login');
    }
  }
  


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const loginFormData = new FormData();
    loginFormData.append("email", formValue.email);
    loginFormData.append("password", formValue.password);
  
    try {
      const response = await axios.post(api, loginFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      // Vérifie la valeur renvoyée
      console.log("Réponse login:", response.data);
  
      // Si le backend renvoie un token
      if (response.data && response.data !== "erreur") {
        await TokenStorage(response.data);
      } else {
        alert("Erreur de connexion");
      }
  
    } catch (error) {
      console.log("Erreur axios:", error);
    }
  };
  
  return (
   <main className="main-content  mt-0">
  <section>
    <div className="page-header min-vh-75">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">
            <div className="card card-plain mt-8">
              <div className="card-header pb-0 text-left bg-transparent">
                <h3 className="font-weight-bolder text-info text-gradient">Administration</h3>
                <p className="mb-0">Barka Da Zoua</p>
              </div>
              <div className="card-body">
                <form role="form" onSubmit={handleSubmit}>
                  <label>Email</label>
                  <div className="mb-3">
                    <input value={formValue.email} onChange={handleChange} name="email"type="email" className="form-control" placeholder="Email" aria-label="Email" aria-describedby="email-addon" />
                  </div>
                  <label>Mots de passe</label>
                  <div className="mb-3">
                    <input type="password"  value={formValue.password}  onChange={handleChange} name="password" className="form-control" placeholder="Mots de passe" aria-label="Password" aria-describedby="password-addon" />
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn bg-gradient-info w-100 mt-4 mb-0">Connexion</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <img src="../assets/img/logo.png" style={{width:"80%",height:"80%"}}/>
            
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

  )
}
export default Login;